import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Dialog from '../Dialog';
import './BaseSlideModal.css';

const BaseSlideModal = ({ children, wrapperStyle = {}, ...dialogPropsIn }) => {
  const {
    className,
    wrapperClassName,
    headingClassName,
    headingStyle,
    contentClassName,
    contentStyle,
    actionsClassName,
    actionsStyle,
    headingTitle,
    headingDescription,
    title,
    subtitle,
    heading,
    actions,
    consumerLayout,
    ...dialogRest
  } = dialogPropsIn;

  const useCustomHeadingOnly = heading != null;

  const mergedWrapperStyle = {
    maxWidth: 500,
    width: '100%',
    ...wrapperStyle,
  };

  return (
    <Dialog
      {...dialogRest}
      className={clsx('alf-base-slide-modal', className)}
      consumerLayout={consumerLayout}
      headingTitle={useCustomHeadingOnly ? undefined : headingTitle}
      headingDescription={useCustomHeadingOnly ? undefined : headingDescription}
      heading={heading}
      title={title}
      subtitle={subtitle}
      wrapperClassName={clsx('alf-base-slide-modal__wrapper', wrapperClassName)}
      wrapperStyle={mergedWrapperStyle}
      headingClassName={clsx('alf-base-slide-modal__heading', headingClassName)}
      headingStyle={headingStyle}
      contentClassName={clsx('alf-base-slide-modal__content', contentClassName)}
      contentStyle={contentStyle}
      actionsClassName={clsx('alf-base-slide-modal__actions', actionsClassName)}
      actionsStyle={actionsStyle}
      actions={actions}
    >
      {children}
    </Dialog>
  );
};

BaseSlideModal.propTypes = {
  children: PropTypes.node,
  wrapperStyle: PropTypes.object,
};

export default BaseSlideModal;
